import {faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Switch} from 'antd';
import React, {useEffect} from 'react';

import {Text} from '../../../../../../../component/text/text';
import {AdditionalInfo} from '../../../../../../../layout/additional-info/additional-info';
import {Locale} from '../../../../../../../provider/locale/localization';
import {useUser} from '../../../../../../../provider/user/user-hook';
import {Form} from '../../../../../../../typings/antd';
import {classNames} from '../../../../../../../util/css';
import {EmailsFormItem} from '../../../../../settings/users/form/email-form-item/emails-form-item';
import {FeedFormKeyEnum, FeedFormType} from '../feed-form-type';

import * as styles from './emails-for-validation.scss';

type PropsType = {
    className?: string;
};

// Validator/import block: lets the user opt into e-mailing the validation results.
// Supports one or more recipients (add via the "+" button). For the authorized
// validator/import the first recipient is prefilled with the current user's e-mail;
// the public validator starts with an empty field. See DEV-14383 / DEV-14349.
export function EmailsForValidation(props: PropsType): React.JSX.Element {
    const {className} = props;

    const form = Form.useFormInstance<FeedFormType>();
    const {user} = useUser();

    const isSendResultsToEmail = Form.useWatch(FeedFormKeyEnum.SendResultsToEmail, form);

    useEffect(() => {
        if (!isSendResultsToEmail) {
            form.resetFields([FeedFormKeyEnum.EmailsForSendResults]);

            return;
        }

        if (user) {
            form.setFieldValue(FeedFormKeyEnum.EmailsForSendResults, [user.email]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSendResultsToEmail, user]);

    return (
        <div className={classNames(styles.EmailsForValidation, className)}>
            <div className={styles.EmailsForValidation_header}>
                <div className={styles.EmailsForValidation_label}>
                    <Text bolder stringKey="FEED__VALIDATION__EMAILS__SEND_TO_EMAIL" />

                    <AdditionalInfo icon={<FontAwesomeIcon color="#8c8c8c" icon={faCircleInfo} />} placement="bottom">
                        <Locale stringKey="FEED__VALIDATION__EMAILS__SEND_TO_EMAIL__INFO" />
                    </AdditionalInfo>
                </div>

                <Form.Item<FeedFormType> name={FeedFormKeyEnum.SendResultsToEmail} noStyle valuePropName="checked">
                    <Switch />
                </Form.Item>
            </div>

            {isSendResultsToEmail && (
                <div className={styles.EmailsForValidation_emailField}>
                    <EmailsFormItem
                        formInputTitle="FEED__VALIDATION__EMAILS__EMAIL_LABEL"
                        hasInitialEmails={false}
                        isRequired
                        name={FeedFormKeyEnum.EmailsForSendResults}
                    />
                </div>
            )}
        </div>
    );
}
